import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ModalStyled } from 'src/components';
import type { CartGetData } from 'src/types';
import { useShowBlockedRetailerModal } from '.';

const BANNED_GIF_URL = 'https://assets.share-a-cart.com/images/next/retailer-banned.gif';
const DISABLED_GIF_URL = 'https://assets.share-a-cart.com/images/next/retailer-disabled.gif';

type Props = {
  cart: CartGetData;
};

export const BlockedRetailerModal = ({ cart }: Props) => {
  const { isOpen, reason } = useShowBlockedRetailerModal({ cart });
  const { t } = useTranslation();

  const titleKey =
    reason === 'disabled'
      ? 'popup.disabled_retailer_title'
      : 'popup.banned_retailer_title';

  const ctaKey =
    reason === 'disabled'
      ? 'popup.disabled_retailer_cta'
      : 'popup.banned_retailer_cta';

  return (
    <ModalStyled
      open={isOpen}
      onClose={() => {}}
      closeOnOutsideClick={false}
      showCloseButton={false}
    >
      <div className='flex flex-col items-center justify-center gap-4 p-4 sm:gap-5 sm:p-5 md:gap-6 md:p-6 lg:gap-8 lg:p-8'>
        <div className='flex w-full max-w-[320px] items-center justify-center'>
          <img
            src={reason === 'disabled' ? DISABLED_GIF_URL : BANNED_GIF_URL}
            width='full'
            height='auto'
            alt={reason === 'disabled' ? 'Retailer temporarily unavailable' : 'Retailer has been banned'}
          />
        </div>
        <div className='flex flex-col items-center justify-center gap-2 md:gap-4 lg:gap-6'>
          <h3 className='heading-300 text-pretty text-center'>
            {t(titleKey)}
          </h3>
          <p className='text-200 text-center xs:px-2 sm:px-4'>
            {reason === 'disabled' ? (
              <Trans
                i18nKey='popup.disabled_retailer_body'
                values={{ retailer: cart?.vendorDisplayName }}
                components={{ email: <a href='mailto:feedback@share-a-cart.com' className='underline' /> }}
              />
            ) : (
              t('popup.banned_retailer_body')
            )}
          </p>
        </div>

        <div className='flex w-full items-center justify-center'>
          <Link to='/get' className='button-primary h-12'>
            {t(ctaKey)}
          </Link>
        </div>
      </div>
    </ModalStyled>
  );
};
